export default __webpack_public_path__ + "static/1845-3bf8b5bc42174f9e364259b1437122a7.gif";